import * as React from "react"
import '../scss/section.scss'

const Section = ({children, secondary, leftAligned, className, style}: {
    children: any,
    secondary?: boolean,
    leftAligned?: boolean,
    className?: string,
    style?: object
}) => {
    return <section style={style} className={
        "Section__Container " +
        (secondary? "Section__Container--secondary primary-background-color " : "") +
        (leftAligned? "Section__Container--leftAligned " : "") +
        (className? className : "")}>
        <div className="Section__Content">

        {children}
        </div>
    </section>
}

export default Section